import Transactions from '../../../Transactions/Transactions';

const MerchantTransactions = () => {
  return <Transactions setShowTransactions={() => {}} />;
};

export default MerchantTransactions;
